import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { LandingPageTeaser } from 'cpnl-common';
import { fetchLandingPageTeaser } from './LandingPageTeaserSlice';
import { LandingPageTeaserContentSelector } from './LandingPageTeaserContentSelector';

export function useLandingPageTeaser(): AbstractContentState<LandingPageTeaser> {
    return useCmsContent(fetchLandingPageTeaser, LandingPageTeaserContentSelector);
}
